// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2e_yP","colCheckbox":"styles_colCheckbox__3Bsv3"};